import React from 'react'
import getTransitionStyle from '../utils/getTransitionStyle'
import logo from "../images/logo_white-2.svg"

export default ({ data, transition, title }) => {
  const delay = 1000
  const status = transition ? transition.status : "entering"

  const titleAppearsFromBottom = getTransitionStyle(
    status, 800, 0, 'textAppearsNoExiting'
  )

  const lineTransitionLeft = getTransitionStyle(
    status, 1000, delay, 'introLineTransitionLeft'
  )

  const lineTransitionRight = getTransitionStyle(
    status, 1000, delay, 'introLineTransitionRight'
  )

  return (
    <div className="intro">
      <div className="intro__container">
        <div className="transition__line--left" style={lineTransitionLeft} />
        <div className="transition__line--right" style={lineTransitionRight} />
        <div className="intro__title--interchangeability" style={titleAppearsFromBottom}>
          {title}
        </div>
      </div>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/IntroInterchangeability.js